import { Document, Page, Text, View } from "@react-pdf/renderer";
import { styles } from "../../../../components/Pdf/pdfGeneral/EstiloPdf";
import { peticionesReceiver } from "../../../../helpers/peticionesReceiver";
import Notification from "../../../../components/Notification/Notification";
import HeaderReport from "../../../../components/Pdf/Header";
import { toast } from "react-toastify";

const formatter = new Intl.NumberFormat("es-MX", {
  style: "currency",
  currency: "MXN",
});

const API = peticionesReceiver();

let deductionsPerceptions = {};

const datatypeUnder = (data) => {
  const type = {
    headers: ["Concepto", "Partida", "Concepto", "Importe"],
    perceptions: [],
    deductions: [],
    totalPerceptions: ["Total de percepciones"],
    totalDeductions: ["Total de deducciones"],
    total: ["Total de neto"],
  };
  let totalPerceptions = 0,
    totalDeductions = 0;
  data.map((obj) => {
    if (obj.keyTypeUnder === 1 || obj.keyTypeUnder === "1") {
      type.perceptions.push([
        obj.under,
        obj.account,
        obj.nameUnder,
        obj.amount,
      ]);

      totalPerceptions += obj.amount ? +obj.amount : 0;
    } else {
      type.deductions.push([obj.under, obj.account, obj.nameUnder, obj.amount]);

      totalDeductions += obj.amount ? +obj.amount : 0;
    }
  });
  type.totalPerceptions.push(totalPerceptions);
  type.totalDeductions.push(totalDeductions);

  deductionsPerceptions = type;
};

const insertTitles = (model, title) => {
  return (
    <>
      <HeaderReport/>
      <View>
        <Text style={styles.title}>{title}</Text>
      </View>
      <View>
        
        <Text style={styles.subTitle}>
          {model.filters !== undefined
            ? model.filters.onlyMessage === true
              ? model.filters.message
              : ""
            : ""}
        </Text>
      </View>
    </>
  );
};

const insertStaff = (staff, data) => {
  const levelrange = [];
  if(data.level) levelrange.push(data.level);
  if(data.subLevel) levelrange.push(data.subLevel);
  if(data.rango) levelrange.push(data.rango);
  return (
    <>
      <View style={styles.table}>
        <View style={styles.cellHeader100Borders}>
          <Text>{"Personal general"}</Text>
        </View>
        <View style={styles.tableRow}>
          <View style={styles.tableRowContainer}>
            <View style={styles.cell50BorderSides}>
              <Text>
                <Text style={styles.textBold}>NO. EMPLEADO: </Text>
                {staff.staffNumber}
              </Text>
            </View>
            <View style={styles.cell50}>
              <Text>
                <Text style={styles.textBold}> NOMBRE: </Text> {staff.name}{" "}
              </Text>
            </View>
          </View>
        </View>
        <View style={styles.tableRow}>
          <View style={styles.tableRowContainer}>
            <View style={styles.cell50BorderSides}>
              <Text>
                <Text style={styles.textBold}> ADSCRIPCION: </Text>{" "}
                {staff.nameArea}{" "}
              </Text>
            </View>
            <View style={styles.cell50}>
              <Text>
                <Text style={styles.textBold}> REGION: </Text>{" "}
                {staff.nameBuilding}{" "}
              </Text>
            </View>
          </View>
        </View>
        <View style={styles.tableRow}>
          <View style={styles.tableRowContainer}>
            <View style={styles.cell33BorderSides}>
              <Text>
                <Text style={styles.textBold}> PUESTO LABORAL: </Text>{" "}
                {staff.nameJob}{" "}
              </Text>
            </View>
            <View style={styles.cell33BorderRigth}>
              <Text>
                <Text style={styles.textBold}> NIVEL-RANGO: </Text>
                {levelrange.join("-")}
              </Text>
            </View>
            <View style={styles.cell33}>
              <Text>
                <Text style={styles.textBold}> TIPO NOMBRAMIENTO: </Text>{" "}
                {staff.nameAssignment}{" "}
              </Text>
            </View>
          </View>
        </View>

        <View style={styles.tableRow}>
          <View style={styles.tableRowContainer}>
            <View style={styles.cell33BorderSides}>
              <Text>
                <Text style={styles.textBold}> FECHA DE INGRESO: </Text>{" "}
                {staff.startJobDate}
              </Text>
            </View>
            <View style={styles.cell33BorderRigth}>
              <Text>
                <Text style={styles.textBold}> CURP: </Text> {staff.curp}{" "}
              </Text>
            </View>
            <View style={styles.cell33}>
              <Text>
                <Text style={styles.textBold}> RFC: </Text> {staff.rfc}{" "}
              </Text>
            </View>
          </View>
        </View>

        <View style={styles.tableRow}>
          <View style={styles.tableRowContainer}>
            <View style={styles.cell50BorderSides}>
              <Text>
                <Text style={styles.textBold}> FECHA DE INGRESO ISSEMYM: </Text>{" "}
                {staff.SecurityKeyStartDate}{" "}
              </Text>
            </View>
            <View style={styles.cell50}>
              <Text>
                <Text style={styles.textBold}> CLAVE ISSEMYM: </Text>{" "}
                {staff.socialSecurityKey}{" "}
              </Text>
            </View>
          </View>
        </View>

        <View style={styles.tableRow}>
          <View style={styles.tableRowContainer}>
            <View style={styles.cell33BorderSides}>
              <Text>
                <Text style={styles.textBold}> BANCO: </Text> {staff.nameBank}{" "}
              </Text>
            </View>
            <View style={styles.cell33BorderRigth}>
              <Text>
                <Text style={styles.textBold}> CUENTA: </Text> {staff.cuenta}{" "}
              </Text>
            </View>
            <View style={styles.cell33}>
              <Text>
                <Text style={styles.textBold}> CLABE: </Text> {staff.clabe}{" "}
              </Text>
            </View>
          </View>
        </View>
        <View style={styles.tableRow}>
          <View style={styles.cell100BorderLRB}>
            <Text>
              <Text style={styles.textBold}> ESTATUS: </Text>
              {staff.statusStaff}
            </Text>
          </View>
        </View>
      </View>
    </>
  );
};

const insertPerceptions = () => {
  return (
    <>
      <View style={styles.table50}>
        <View style={styles.tableRow} fixed>
          <View style={styles.cellHeader25Borders}>
            <Text>{"Concepto"}</Text>
          </View>
          <View style={styles.cellHeader25BordersRTB}>
            <Text>{"Partida"}</Text>
          </View>
          <View style={styles.cellHeader25BordersRTB}>
            <Text>{"Concepto"}</Text>
          </View>
          <View style={styles.cellHeader25BordersRTB}>
            <Text>{"Importe"}</Text>
          </View>
        </View>

        {deductionsPerceptions.perceptions.length > 0 &&
          deductionsPerceptions.perceptions.map((info, index) => (
            <View style={styles.tableRow} wrap={false}>
              <View style={[styles.cellContent25BordersLBR,{fontSize: 6, textAlign:"left"}]}>
                <Text>{info[0]} </Text>
              </View>
              <View style={[styles.cellContent25BordersRB,{fontSize: 6, textAlign:"left"}]}>
                <Text>{info[1]} </Text>
              </View>
              <View style={[styles.cellContent25BordersRB,{fontSize: 6, textAlign:"left"}]}>
                <Text>{info[2]} </Text>
              </View>
              <View style={[styles.cellContent25BordersRB,{fontSize: 6, textAlign:"left"}]}>
                <Text>{formatter.format(info[3])} </Text>
              </View>
            </View>
          ))}
        <View style={styles.tableRow}>
          <View style={styles.cellContent75BordersLBR}>
            <Text style={[styles.textBold, {fontSize: 6, textAlign:"left"} ]}>
              {deductionsPerceptions.totalPerceptions[0]}{" "}
            </Text>
          </View>
          <View style={[styles.cellContent25BordersRB,{fontSize: 6, textAlign:"left"}]}>
            <Text>{formatter.format(deductionsPerceptions.totalPerceptions[1])} </Text>
          </View>
        </View>
      </View>
    </>
  );
};

const insertDeductions = () => {
  return (
    <>
      <View style={styles.table50}>
        <View style={styles.tableRow} fixed>
          <View style={styles.cellHeader25Borders}>
            <Text>{"Concepto"}</Text>
          </View>
          <View style={styles.cellHeader25BordersRTB}>
            <Text>{"Partida"}</Text>
          </View>
          <View style={styles.cellHeader25BordersRTB}>
            <Text>{"Concepto"}</Text>
          </View>
          <View style={styles.cellHeader25BordersRTB}>
            <Text>{"Importe"}</Text>
          </View>
        </View>

        {deductionsPerceptions.deductions.length > 0 &&
          deductionsPerceptions.deductions.map((info, index) => (
            <View style={styles.tableRow} wrap={false}>
              <View style={[styles.cellContent25BordersLBR, {fontSize: 6, textAlign:"left"}]}>
                <Text>{info[0]} </Text>
              </View>
              <View style={[styles.cellContent25BordersRB, {fontSize: 6, textAlign:"left"}]}>
                <Text>{info[1]} </Text>
              </View>
              <View style={[styles.cellContent25BordersRB, {fontSize: 6, textAlign:"left"}]}>
                <Text>{info[2]} </Text>
              </View>
              <View style={[styles.cellContent25BordersRB, {fontSize: 6, textAlign:"left"}]}>
                <Text>{formatter.format(info[3])} </Text>
              </View>
            </View>
          ))}
        <View style={styles.tableRow}>
          <View style={[styles.cellContent75BordersLBR, {fontSize: 6, textAlign:"left"}]}>
            <Text style={styles.textBold}>
              {deductionsPerceptions.totalDeductions[0]}
            </Text>
          </View>
          <View style={[styles.cellContent25BordersRB,{fontSize: 6, textAlign:"left"}]}>
            <Text>{formatter.format(deductionsPerceptions.totalDeductions[1])}</Text>
          </View>
        </View>
        <View style={styles.tableRow}>
          <View style={[styles.cellContent75BordersLBR,{fontSize: 6, textAlign:"left"}]}>
            <Text style={styles.textBold}>{deductionsPerceptions.total}</Text>
          </View>
          <View style={[styles.cellContent25BordersRB,{fontSize: 6, textAlign:"left"}]}>
            <Text>
              {formatter.format((
                deductionsPerceptions.totalPerceptions[1] -
                deductionsPerceptions.totalDeductions[1]
              ))}
            </Text>
          </View>
        </View>
      </View>
    </>
  );
};

const getStaff = async (data) => {
  let staff = [];
  const params = {
    action: "getStaffData",
    idStaff: data[0].idStaff,
  };
  await API.peticionEndPoint(params, "app/facades/reports/reportsF.php")
    .then((res) => {
      if (res.status === 200) {
        
        staff = res.data.data[0];
      } else {
        toast(
          <Notification
            type={"consultar_error"}
            backMessage={res.data.message}
            withIcon
          />
        );
      }
    })
    .catch((err) => {
      toast(<Notification type={"consultar_servidor_error"} withIcon />);
    });
  return staff;
};

export async function generatePdfPercepcionesDeducciones(
  data,
  model,
  title,
  fileNo
) {
  datatypeUnder(data);
  const staff = await getStaff(data);
  return {
    report: (
      <>
        <Document>
          <Page style={styles.body}>
            {/* Titulos */}

            {insertTitles(model, title)}
            {/* Inserta usuario */}
            {insertStaff(staff, data[0])}

            {/* insertar percepciones */}

            <View style={styles.tableRow}>
              <Text style={styles.text50}>Percepciones</Text>
              <Text style={styles.text50}>Deducciones</Text>
            </View>
            <View style={styles.tableRow}>
              {insertPerceptions()}

              {insertDeductions()}
            </View>

            <View fixed style={styles.spaceFooter}></View>
            <View fixed style={styles.footer}>
              <Text style={styles.textFooter}>{fileNo}</Text>
              <Text
                style={styles.textFooter}
                render={({ pageNumber, totalPages }) =>
                  `PAGINA : ${pageNumber} / ${totalPages}`
                }
              />
            </View>
          </Page>
        </Document>
      </>
    ),
  };
}
